<template>
    <div class="upload-video">
        <upload-button
            ref="uploadButton"
            v-model="innerValue"
            accept="video/*"
            :disabled="buttonDisabled"
            :folder="folder"
            :max="1"
            :max-size="maxSize"
            :tip="tip"
            :title="title"
            @change="handleChange" />
        <div v-if="currentUrl" class="video-preview">
            <video class="video-player" :src="currentUrl" controls preload="metadata">
                您的浏览器不支持视频预览
            </video>
            <div v-if="!disabled" class="video-actions">
                <el-button type="text" class="video-remove" @click="removeVideo">删除视频</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UploadVideo',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        },
        folder: {
            type: String,
            default: ''
        },
        maxSize: {
            type: Number,
            default: 100
        },
        tip: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: '上传视频'
        }
    },
    data() {
        return {
            innerValue: this.normalizeFileList(this.value)
        }
    },
    computed: {
        currentUrl() {
            return this.innerValue[0] ? this.innerValue[0].url : ''
        },
        buttonDisabled() {
            return this.disabled || this.innerValue.length >= 1
        }
    },
    watch: {
        value(val) {
            this.innerValue = this.normalizeFileList(val)
        }
    },
    methods: {
        normalizeFileList(list) {
            if (!Array.isArray(list)) {
                return []
            }
            return list.map(item => {
                if (typeof item === 'string') {
                    return {
                        url: item,
                        name: item.split('/').pop()
                    }
                }
                return { ...item }
            })
        },
        openPicker() {
            if (this.$refs.uploadButton) {
                this.$refs.uploadButton.openPicker()
            }
        },
        handleChange(fileList) {
            this.innerValue = this.normalizeFileList(fileList)
            this.$emit('input', this.innerValue)
            this.$emit('change', this.innerValue)
        },
        removeVideo() {
            this.handleChange([])
        }
    }
}
</script>

<style scoped>
.video-preview {
    width: 375px;
    margin-top: 12px;
    padding: 12px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    background: #fafafa;
    box-sizing: border-box;
}

.video-player {
    display: block;
    width: 100%;
    max-height: 280px;
    background: #000;
    border-radius: 4px;
}

.video-actions {
    margin-top: 8px;
    text-align: right;
}

.video-remove {
    color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadVideo.vue